module.exports = __webpack_public_path__ + "static/img/xiangqing2.e9bb2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiangqing2.png
// module id = I6Hd
// module chunks = 24